import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton';

const Add = require('react-icons/lib/md/add');

const Feedback = require('react-icons/lib/md/feedback');

const contentStyle = {
  margin: 20,
  textAlign: 'left',
  display: 'inline-block',
};

export default class Welcome extends Component {
  render() {
    const { onNext } = this.props;

    return (
      <div>
        <h1>Ratzgiwatz Jugendprogramm Web-Anmeldung</h1>
        <h3>Informationen und Bestätigungslink per E-Mail</h3>
        <Feedback size={60}/>
        <br/>
        <div className="text" style={contentStyle}>
          Vielen Dank für die Anmeldung zu Ratzgiwatz.
          <br/><br/>
          In Kürze werden Sie eine E-Mail erhalten, in der alle weiteren Informationen und Termine enthalten sind.
          <br/><br/>
          <strong>
            Zudem erhalten Sie in dieser E-Mail einen Link, mit dem Sie die
            Anmeldung bestätigen müssen.
            Erst nach Aufruf des Bestätigungslinks ist die Anmeldung gültig
          </strong>.
          <br/><br/>
          Bitte kontrollieren Sie Ihren Spam Ordner falls die E-Mail nicht bei Ihnen
          eintrifft. Wenn Sie die Mail nach 15 Minuten nicht erhalten haben, können
          Sie sich an <a href="mailto:anmeldung-jugendprogramm@ratzgiwatz.de">anmeldung-jugendprogramm@ratzgiwatz.de</a> wenden.
          <br/><br/>
          Wir freuen uns schon auf eine Woche voller Spiel, Spaß und lachender Gesichter.
          <br/><br/>
          Ihr Ratzgiwatz-Leiter-Team.
        </div>
        <br/>
        <RaisedButton
          label="Weitere Anmeldung durchführen."
          primary={true}
          icon={<Add/>}
          onTouchTap={onNext}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/anmeldung-abgeschlossen/AnmeldungAbgeschlossen.jsx